module.exports = __webpack_public_path__ + "static/media/RawsonPro-Bold.49733096.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/RawsonPro/Bold/RawsonPro-Bold.woff
// module id = 361
// module chunks = 17